import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 采集数据录入
 */
const collectionData = {

  /**
   * 录入采集数据
   */
  factitiousEnterCollectionData (measureId, pointCode, pointNumber, data, froce, logThisAction) {
    return axios.post(base.collectionData.factitiousEnterCollectionData, utils.postParamsArrayToJsonString({ measureId, pointCode, pointNumber, data, froce, logThisAction }))
  },
  /**
   * 查询采集数据录入记录
   */
  getCollectionDataFactitiousEnteringLog1 (companyId, measuresId, startEnteringTime, endEnteringTime) {
    return axios.post(base.collectionData.getCollectionDataFactitiousEnteringLog1, utils.postParamsArrayToJsonString({ companyId, measuresId, startEnteringTime, endEnteringTime }))
  },
  /**
   * 查询采集数据录入记录
   */
  getCollectionDataFactitiousEnteringLog2 (companyId, measuresId, startDataTime, endDataTime) {
    return axios.post(base.collectionData.getCollectionDataFactitiousEnteringLog2, utils.postParamsArrayToJsonString({ companyId, measuresId, startDataTime, endDataTime }))
  },
  /**
   * 录入统计数据
   * @param {*} measureId 
   * @param {*} pointCode 
   * @param {*} pointNumber 
   * @param {*} segmentId 
   * @param {*} timeGranularity 
   * @param {*} values 
   * @param {*} froce 
   * @param {*} logThisAction 
   * @returns 
   */
  factitiousEnterQuantitiyData (measureId, pointCode, pointNumber, segmentId, timeGranularity, values, froce, logThisAction) {
    return axios.post(base.collectionData.factitiousEnterQuantitiyData, utils.postParamsArrayToJsonString({ measureId, pointCode, pointNumber, segmentId, timeGranularity, values, froce, logThisAction }))
  },
  /**
   * 查询统计数据录入记录 
   * @param {*} companyId 
   * @param {*} measuresId 
   * @param {*} segmentsId 
   * @param {*} timeGranularity 
   * @param {*} startEnteringTime 
   * @param {*} endEnteringTime 
   * @returns 
   */
  getQuantitiyDataFactitiousEnteringLog1 (companyId, measuresId, segmentsId, timeGranularity, startEnteringTime, endEnteringTime) {
    return axios.post(base.collectionData.getQuantitiyDataFactitiousEnteringLog1, utils.postParamsArrayToJsonString({ companyId, measuresId, segmentsId, timeGranularity, startEnteringTime, endEnteringTime }))
  },
  /**
   * 查询统计数据录入记录
   * @param {*} companyId 
   * @param {*} measuresId 
   * @param {*} segmentsId 
   * @param {*} timeGranularity 
   * @param {*} startEnteringTime 
   * @param {*} endEnteringTime 
   * @returns 
   */
  getQuantitiyDataFactitiousEnteringLog2 (companyId, measuresId, segmentsId, timeGranularity, startDataTime, endDataTime) {
    return axios.post(base.collectionData.getQuantitiyDataFactitiousEnteringLog1, utils.postParamsArrayToJsonString({ companyId, measuresId, segmentsId, timeGranularity, startDataTime, endDataTime }))
  }
}

export default collectionData